import React, { useEffect, useState } from 'react';
import { Select, HStack } from '@chakra-ui/react';

interface MonthYearSelectProps {
  value?: string; // Format: "yyyy-MM"
  onChange: (value: string) => void;
}

const MonthYearSelect: React.FC<MonthYearSelectProps> = ({ value, onChange }) => {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  useEffect(() => {
    if (value) {
      const [y, m] = value.split('-');
      setYear(y);
      setMonth(m);
    }
  }, [value]);

  useEffect(() => {
    if (month && year) {
      onChange(`${year}-${month}`);
    }
  }, [month, year, onChange]);

  const months = [
    { label: 'Jan', value: '01' },
    { label: 'Feb', value: '02' },
    { label: 'Mar', value: '03' },
    { label: 'Apr', value: '04' },
    { label: 'May', value: '05' },
    { label: 'Jun', value: '06' },
    { label: 'Jul', value: '07' },
    { label: 'Aug', value: '08' },
    { label: 'Sep', value: '09' },
    { label: 'Oct', value: '10' },
    { label: 'Nov', value: '11' },
    { label: 'Dec', value: '12' },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 31 }, (_, i) => (currentYear  + i).toString()); 

  return (
    <HStack spacing={2}>
      <Select
        placeholder="Month"
        value={month}
        onChange={(e) => setMonth(e.target.value)}
        borderRadius="30px"
      >
        {months.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>

      <Select
        placeholder="Year"
        value={year}
        onChange={(e) => setYear(e.target.value)}
        borderRadius="30px"
      >
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </Select>
    </HStack>
  );
};

export default MonthYearSelect;
